import React, {forwardRef, CSSProperties} from 'react';

import styles from './Action.module.scss';

export interface Props extends React.HTMLAttributes<HTMLButtonElement> {
  active?: {
    fill: string;
    background: string;
  };
  cursor?: CSSProperties['cursor'];
}

export const Action = forwardRef<HTMLButtonElement, Props>(
  ({active, className, cursor, style, ...props}, ref) => {
    return (
      <button
        ref={ref}
        {...props}
        className={`${styles.Action} ${className}`}
        tabIndex={0}
        style={
          {
            ...style,
            position: "absolute",
            top: 0,
            left: 0,
            background: "transperent",
            border: "none",
            width: "100%",
            opacity: "0",
            height: "-webkit-fill-available",
            cursor,
            '--fill': active?.fill,
            '--background': active?.background,
          } as CSSProperties
        }
      />
    );
  }
);
